import { bool } from 'components/columns';
import { CreateScene, DeleteScene, EntityScene, ModelScene, IndexScene, UpdateScene } from 'components';
import { Activity } from 'types';
import { activityKindOptions } from 'options';
import { SearchFilterInput } from 'components/filters/SearchFilterInput';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import permissions from 'modules/core/activity/permissions';
import { Link } from 'react-router-dom';
import { Form } from './Form';
import { ListExport } from 'components/ListActions';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

const columns: ControlledTableColumns<Activity> = [
  {
    content: 'Kind',
    key: 'kind',
    sortable: true,
    width: 100,
  },
  flexColumn({
    content: 'Name',
    key: 'name',
    required: true,
    sortable: true,
    render: ({ id, name }: Activity) => <Link to={`${id}`}>{name}</Link>,
  }),
  bool<Activity>('Non standard', 'non_standard', { sortable: true, width: 150 }),
  bool<Activity>('Is fee', 'is_fee', { sortable: true, width: 150 }),
];

const initialValues = {
  name: '',
  kind: null,
  non_standard: false,
  is_fee: false,
};

const model = {
  endpoint: 'core/activities/',
  permissions,
  title: 'Activity',
  pluralTitle: 'Activities',
  entityTitle: ({ name }: Activity) => name,
};

export const route = {
  path: 'activities',
  element: <ModelScene {...model} />,
  children: [
    {
      index: true,
      element: (
        <IndexScene
          columns={columns}
          filterFields={
            <>
              <SearchFilterInput />
              <SelectFilterChip name="kind" options={activityKindOptions} />
            </>
          }
          toolbar={<ListExport permission={permissions.export} />}
        />
      ),
    },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form update={false} />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene viewDisabled>
              <Form update={true} />
            </UpdateScene>
          ),
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ],
};
